import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class HeroHome {
    constructor() {
        this.section = document.querySelector('.components-block-hero-home');
        this.slider = this.section.querySelector('.swiper--components-block-hero-home');
        this.navigationPrev = document.querySelector('.slider-button-prev--components-block-hero-home');
        this.navigationNext = document.querySelector('.slider-button-next--components-block-hero-home');
        this.pagination = this.section.querySelector('.swiper-pagination-nav--components-block-hero-home');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            pagination: {
                el: this.pagination,
                clickable: true,
            },
            breakpoints: {
                0: {
                    direction: 'horizontal',
                },
                1024: {
                    direction: 'vertical',
                },
            },
        });
    }
}

if (document.querySelector('.components-block-hero-home')) {
    new HeroHome();
}
